import { Component, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { ConsultService } from './consult.service';
// import { viewportMinWidth } from './lib/helpers';
import UIkit from './lib/uikit';

@Component({
  selector: 'app-consult',
  templateUrl: '../templates/consult.component.html',
  styleUrls: ['../styles/components/consult.component.less'],
})
export class ConsultComponent implements AfterViewInit {
  @ViewChild('switcher', { static: false }) switcherRef: ElementRef;
  @ViewChild('chat', { static: false }) chatRef: ElementRef;

  constructor(public consultService: ConsultService) {}

  public ngAfterViewInit() {
    if (typeof window === 'undefined') return;

    const chatEl = this.chatRef.nativeElement;

    window.addEventListener('onBitrixLiveChatSourceLoaded', () => {
      window.setTimeout(() => {

        (<any>window).BX.LiveChat.openLiveChat();
        let timeoutId: number;

        const intervalId = window.setInterval(() => {
          const bxLivechatBox = document.querySelector('.bx-livechat-box');
          if (!bxLivechatBox) return;

          // recreation of meta viewport after loading online chat for mobile
          // viewportMinWidth();

          window.clearInterval(intervalId);
          window.clearTimeout(timeoutId);
          document.body.classList.remove('bx-livechat-mobile-state');
          const bxLivechatHead = bxLivechatBox.querySelector('.bx-livechat-head-wrap');
          const bxLivechatCopyright = bxLivechatBox.querySelector('.bx-livechat-copyright');
          if (bxLivechatHead) bxLivechatHead.remove();
          if (bxLivechatCopyright) bxLivechatCopyright.remove();
          chatEl.innerHTML = '';
          chatEl.append(bxLivechatBox);
        }, 1000);

        timeoutId = window.setTimeout(() => {
          window.clearInterval(intervalId);
          chatEl.innerHTML = '<h3 class="uk-margin-auto uk-margin-auto-vertical">Произошла ошибка при загрузке чата</h3>';
        }, 60000);

      }, 100);
    });

    this.consultService.notifications.push({
      name: 'Обращаем ваше внимание, что на текущий момент магазин работает только с юридическими лицами.',
      status: 'danger',
      createdAt: (new Date()).toISOString(),
      isReaded: false
    });

    UIkit.switcher(this.switcherRef.nativeElement).show(0);
  }

  showDate(i: number): boolean {
    const current = this.consultService.notifications[i];
    const prev = this.consultService.notifications[i - 1];
    if (!prev) return true;
    const currentDate = new Date(current.createdAt).setHours(0, 0, 0, 0);
    const prevDate = new Date(prev.createdAt).setHours(0, 0, 0, 0);
    return (currentDate !== prevDate);
  }	
}